import { SYS102_CSS_VARS, SYS102Params } from './api-service/parameters/SYS102Params';
import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { HistService } from "../hist/services/hist.service";
import { MainLayoutService } from "../layout/services/main-layout.service";
import { AuthenticationService } from "../security/services/authentication.service";
import { EasyFormComponent } from "../shared/components/easy-form/easy-form.component";
import { ValidationTipComponent } from "../shared/components/validation-tip/validation-tip.component";
import { HistApi } from "./api-service/hist/hist-api";
import { ParameterApi } from "./api-service/parameters/parameter-api";
import { PostAreaAPI } from "./api-service/postarea-api";
import { TimeSectionRange } from "./api-service/register/time-section-range";
import { ScheduleApi } from "./api-service/schedule/schedule-api";
import { FullUser, TwoFactorValue, UserApi } from "./api-service/user/user-api";
import { ChildGrowDataChartService } from "./child-grow-chart-service";
import { EasyFormService } from "./easy-form-service";
import { EasyNotificationService } from "./easy-notification.service";
import { MemoryCache } from "./memory-cache-service";
import { SessionService } from "./session.service";
import { UserCache } from "./user-cache";
import { UserConfirmService } from "./user-confirm.service";
import { WebApiService } from "./web-api.service";
import { WebApiClient } from "./web-api-client.service";
import { Schedule } from "../schedule/models/schedule";
import { FontGreatService } from "./font-great.service";
import { SignalRService } from "./signalr-service";
import { Compare, delay, NullOrEmpty } from "../shared/utilities";
import { RegReserveService } from "../registers/reserve/reg-reserve-service";
import { HcrService } from "./hcr-service.service";
import { FormFieldCollection } from "../shared/components/easy-form/form-define";
import { SatellitePharmacyServiceService } from "./satellite-pharmacy-service.service";
import { ClinicDataService } from "./data-service/clinic-data-service";
import { LabApi } from "./api-service/labs/lab-api";
import { AlertOn, AnnounceAlertService } from "./announceAlert.service";
import { ReserveService } from "./reserve.service";
import { bulletinParameter, bulletinResponse, bulletinResult, ToccService } from "./tocc-service.service";
import { AnnouncementApi } from "./api-service/announcement/announcement-api";
import { Announcement } from "./api-service/announcement/announcement-model";
import { DateHelper } from "../shared/helpers/date-helper";
import { ClinicApi, StartUpPreloadDto } from "./api-service/clinic/clinic-api";
import { DengueFormDto, ToccApi } from "./api-service/hist/tocc-api";
import { SystemCodeEditService } from "./system-code-edit.service";
import { ClinicSessionTypeEnum } from "../system/clinic/models/clinicSession";
import { ClinicSession, ClinicSessionApi } from "./api-service/clinic/clinic-session-api.service";
import { BaseConfig, FunctionEnable } from "./base-config.service";
import { RegisterService } from "./register-service";
import { RatingPriceService } from "../hist/services/rating-price.service";
import { OptionTypes } from "./cache-service/options-cached.service";
import { ValueTextPairNumberValue } from "../shared/models/value-text-pair";
import { ProductApi } from "./api-service/stocks/product-api";
import { LoginStockAlertDto } from "../stocks/product/models/product";
import { DentalAdditionApiService, isDentalMountainIslandArea } from "./api-service/dental/dental-addition-api.service";
import { DentalTreatRuleService } from "../hist/services/dental-treat-rule-from-eprohis.service";
import { DebugLogService } from "./debug-log.service";
import { BaseCookieService } from "./cookie-service";
import { ClinicTypeEnum } from "../enums/ClinicTypeEnum";
import { ParamSetApi } from "./api-service/declare/param-set-api";

export declare type VPNState = 'Ok' | 'Slow' | 'Fail';

@Injectable({
  providedIn: 'root'
})
export class StartUpService {
  userData: FullUser;
  api: WebApiService;
  isHomeCare: boolean = UserCache.getLoginUser().Clinic.TypeIsHomeCare;
  isRecoveryHome: boolean = UserCache.getLoginUser().Clinic.TypeIsRecoveryHome;
  isStockHeadquarters = UserCache.IsStockHeadquarters();
  /**藥師下拉選單 */
  pharList = [];
  onReloadSelectPhar: EventEmitter<void> = new EventEmitter();
  onParameterLoaded: EventEmitter<void> = new EventEmitter();
  onStockAlertDetected: EventEmitter<LoginStockAlertDto> = new EventEmitter();
  /**
   *
   */
  private isStart = false;
  constructor(
    private postAreaApi: PostAreaAPI,
    private webApiFactory: WebApiClient,
    private userApi: UserApi,
    private scheduleApi: ScheduleApi,
    private announcement: AnnounceAlertService,
    private paramApi: ParameterApi,
    private mainLayout: MainLayoutService,
    private userConfirm: UserConfirmService,
    private easyForm: EasyFormService,
    private notify: EasyNotificationService,
    private session: SessionService,
    private auth: AuthenticationService,
    private hist: HistApi,
    private histService: HistService,
    private ratingPriceService: RatingPriceService,
    private cgcService: ChildGrowDataChartService,
    private fontGreatService: FontGreatService,
    private signalRService: SignalRService,
    private reserveService: RegReserveService,
    private regService: RegisterService,
    private hcrService: HcrService,
    private satelliteService: SatellitePharmacyServiceService,
    private clinicDataService: ClinicDataService,
    private labApi: LabApi,
    private dReserveService: ReserveService,
    private toccApi: ToccApi,
    private toccService: ToccService,
    private announcementApi: AnnouncementApi,
    private clinicApi: ClinicApi,
    private clinicSessionApi: ClinicSessionApi,
    private systemCodeEditService: SystemCodeEditService,
    private productApi: ProductApi,
    private dentalAdditionApi: DentalAdditionApiService,
    private dentalTreatRuleService: DentalTreatRuleService,
    private cookieService: BaseCookieService,
    private paramSetApi: ParamSetApi,
    private logger:DebugLogService
  ) {
    this.api = this.webApiFactory.createHisService('schedule/shiftschedule');
    this.auth.logoutEvent.subscribe(() => {
      // 清除參數快取
      //this.paramApi.clearCache();
      // 清除們診選項快取
      this.hist.EditOpt = null;
      this.userData = null;
    });
  }
  async start() {
    await this.logger.ClientLog('Info', true, '系統啟動中');
    // 預先載入
    await this.Ping_VPN();
    var data:StartUpPreloadDto = null;
    try{
      data = await this.clinicDataService.preload()
    }catch(e){
      if(e.status == 401){
        this.auth.logout();
      }
    }
    
    // if(!this.clinicDataService.gf.IsWebHIS){
    //   var ret =await this.userConfirm.showConfirm({
    //     title:'警告',
    //     msg:'WebHIS權號尚未開通完成，為了維護您的權益，請聯絡您的輔導人員完成後續作業！',
    //     textYes:'立即登出',
    //     textNo:'繼續使用'
    //   })
    //   if(ret==true){
    //     await this.auth.logout()
    //     return ;
    //   }
    // }
    this.systemCodeEditService.init(data.systemCodeOptions)
    this.onParameterLoaded.emit();
    await this.regService.Init();
    await this.histService.Init();

    // 牙科院所: 預載規則
    if (UserCache.IsDentistMode()) {
      this.dentalAdditionApi.loadRules().catch(err =>
        console.warn('[StartUp] 牙科加成規則預載失敗', err)
      );
      try {
        await this.dentalTreatRuleService.initialize();
        console.log('[StartUp] 牙科處置規則已載入', this.dentalTreatRuleService.ruleCount, '筆');
      } catch (err) {
        console.warn('[StartUp] 牙科處置規則預載失敗', err);
      }
    }
     
    var p = await this.clinicDataService.getParam("REG001");
    var secRange = new TimeSectionRange(p);
    var sec = TimeSectionRange.getSectionValue(secRange);
    this.regService.SetRegDoctorInfo(data.regDoctors,DateHelper.today,sec,this.isHomeCare||this.isRecoveryHome,true);
    this.regService.SetAgeDiscount(data.ageDiscount,DateHelper.today)


    await this.updateUIColor()


    // 載入使用者資料
    await this.getUser();
    await this.checkPwdChange();
    // Task 12024.4 登錄時預設排班表展開功能去除 2023/06/09
    // if (!this.isHomeCare) {
    //     await this.checkMonthSchedule();
    // }
    await this.initByPosition();

    // 載入不分院所資料
    // 郵遞區號


    // 強化快取
    if (FunctionEnable.EnableClientAdvCache) {

      // 重整也不會出現在第一個畫面上的東西-背景
      this.cgcService.load();
    } else {
      await this.postAreaApi.GetCityArea();
      // 載入兒童成長取線資料
      await this.cgcService.load();
      await this.systemCodeEditService.init();
    }
    // 預約掛號設定
    await this.reserveService.init();
    await this.dReserveService.init();

    // 設定需要使用StartUpService的Service，未避免循環參考故不再對方進行注入
    this.fontGreatService.Init(this);
    this.signalRService.startConnection((s) => {

      this.signalRService.userLogin()
    });
    try{

      var a = this.hcrService.onConnected.subscribe(async ()=>{
        a.unsubscribe();
        // 保存快取
        var paramCache = this.clinicDataService.getParamCacheObj()
        var systemCodeCache = this.clinicDataService.getSystemCodeCacheObj();
        for(let key in paramCache){
          data.param[key] = paramCache[key];
        }
        systemCodeCache.forEach((v,k,m)=>{
          data.systemCodes[k] = v;
        })
        var user = UserCache.getLoginUser();
        var cachedObj = {user:user,data:data};
        var jsonContent = JSON.stringify(cachedObj);
        await this.hcrService.CachesSave(jsonContent);
        
      })
      //主控台連線
      await this.hcrService.Connect();
      // preload 已取得 BIGTREE 模組與 API Key，且主控台已可代送 HTTP，於此執行一次背景連線測試。
      void this.initializeSatellitePharmacyConnection();
      if(UserCache.IsPharmacyMode()){
        // 藥局的話開啟背景瀏覽器
        await this.hcrService.SetPharPrinter()
      }

      // 載入TOCC相關內容
      await this.toccService.Initial(this.vpnState);
    }catch(e) {

    }
    await this.getAnnoucementAlert();
    // 打包參數檢查
    await this.checkHeadquartersStockSystemAsync();
    await this.checkStockAlert();

    await this.checkEMRPath();
    this.initIdleMonitor();
    // await this.getAnnoucementAlert();
    // 改到main-layout的ngOnInit()，必須在hcrService.Connect()之後執行，因為呼叫api是透過主控台。
    // await this.getTOCCBulletin().then(async () => {
    //   setTimeout(async () => {
    //     await this.getAnnoucementAlert();
    //   }, 1000);
    // });
    
  }

  private async initializeSatellitePharmacyConnection(): Promise<void> {
    if (!this.satelliteService.useSatellite()) {
      return;
    }

    try {
      await this.satelliteService.trySend('', false);
    } catch {
      // 連線結果由 SatellitePharmacyServiceService 保存並透過事件通知，不中斷系統啟動。
    }
  }

  private async getUser() {
    var user = UserCache.getLoginUser();
    if (FunctionEnable.EnableClientAdvCache) {
      // Get User Data
      this.userData = await this.clinicDataService.GetCurrentUser();
    } else {
      // Get User Data
      this.userData = await this.userApi.getFullUser(user.UserId);
    }


    //服務專線後面加上客服分機
    var phone = await this.clinicApi.GetServicePhone(user.Clinic.Code);
    user.Clinic.ServicePhone = phone;
  }

  async initByPosition() {
    // 醫師 -- 都顯示
    // if (this.isDoctor()) {
    // 醫師預載入院內資料
    if (FunctionEnable.EnableClientAdvCache) {
      //await this.histService.Init();
    } else {
      await this.hist.getEditOptions();
    }

    // var phSelected = this.session.getPhar();
    // 登入後為空, null是無藥師
    // if (phSelected == undefined) {
    // if (UserCache.getLoginUser().Clinic.HasPharmacist) {

    await this.showSelectPhar();   // 不論有無藥師都要顯示，要讓院所勾選是否寫卡和衛星藥局


    // }
    // }
    // }
  }

  private isDoctor() {
    return this.userData.positions.find(p => p.value == '10' || p.value == '11');
  }

  private isPharm() {
    this.userData.positions.find(p => p.value == '40' || p.value == '41' || p.value == '42')
  }

  getTypeDescription(type: ClinicSessionTypeEnum): string {
    switch (type) {
      case ClinicSessionTypeEnum.Normal:
        return "院內";
      case ClinicSessionTypeEnum.OutVisit:
        return "巡診";
      case ClinicSessionTypeEnum.OutVisitJail:
        return "監獄";
      case ClinicSessionTypeEnum.OutVisitMedLackArea:
        return "醫缺";
      case ClinicSessionTypeEnum.OutVisitMtn:
        return "山離";
      default:
        return "";
    }
  }

  public async showSelectPhar() {

    // 取一些參數設定
    var p = await this.clinicDataService.getParam("REG001");
    var secRange = new TimeSectionRange(p);
    var sec = TimeSectionRange.getSectionValue(secRange);
    var hst001 = await this.clinicDataService.getParam("HST001");
    var sitlist: ClinicSession[];
    if (FunctionEnable.EnableClientAdvCache) {
      sitlist = await this.clinicDataService.GetClinicSessions();
    } else {
      /**撈本院情境 前端送0，後端會取本院的資料 */
      sitlist = await this.clinicSessionApi.GetAll(0);
    }
    sitlist = sitlist.sort((a, b) => a.Type - b.Type);
    /**情境下拉選項，衛星IP與巡診table */
    var sit = [];

    if (!sitlist?.some(item => item.Type == ClinicSessionTypeEnum.Normal)) {
      sit.push({ text: '一般院內 [衛星:無]', value: 0 })
    }

    if (sitlist?.length > 0) {
      sit.push(...sitlist.map(item => ({
        text: `${item.Name} [${item.SatellitePhamacyIP ? '衛星:有' : '衛星:無'}${'_類型:' + this.getTypeDescription(item.Type)}${item.DefaultSPTX ? '_特治:' + item.DefaultSPTX : ''}${item.DefaultSpecAreaSV ? '_註記:' + item.DefaultSpecAreaSV : ''}${item.DefaultSupArea ? '_支援地區:' + item.DefaultSupArea : ''}]`,
        value: item.Id
      })));
    }

    //藥師 下拉選項
    let ph:ValueTextPairNumberValue[]=[]
    if(FunctionEnable.EnableClientAdvCache){
      var user = UserCache.getLoginUser().UserId;
      var phars =await this.clinicDataService.getOptions(OptionTypes.Pharmacist);
      var scheduledDoc = await this.clinicDataService.GetDoctorSchdule(DateHelper.today);
      var scheduledPh = await this.clinicDataService.GetPharSchdule(DateHelper.today);
      var roomCode = (await this.clinicDataService.getSystemCodes(['C0120']))['C0120'];
      // 自己為醫師時 按照排班表的對應藥師
      var defaultPharm = scheduledDoc.find(s => s.UserId == user && s.TimeSec ==sec)?.DefaPharm;
      var phTemp = [...phars].sort((a, b) =>
      {
        // 檢查藥師是否在班表中（不限時段）
        var isASchedule = scheduledPh.some(s => s.UserId == a.value);
        var isBSchedule = scheduledPh.some(s => s.UserId == b.value);
        
        // 檢查藥師是否在對應時段的班表中
        var isAScheduleInTimeSec = scheduledPh.some(s => s.UserId == a.value && s.TimeSec == sec);
        var isBScheduleInTimeSec = scheduledPh.some(s => s.UserId == b.value && s.TimeSec == sec);
        
        // 對應藥師最優先
        if (a.value == defaultPharm) return -1;
        if (b.value == defaultPharm) return 1;
        
        // 對應時段的藥師次優先
        if (isAScheduleInTimeSec && !isBScheduleInTimeSec) return -1;
        if (!isAScheduleInTimeSec && isBScheduleInTimeSec) return 1;
        if (isAScheduleInTimeSec && isBScheduleInTimeSec) return Compare(a.text, b.text);
        
        // 有在班表中的優先（不限時段）
        if (isASchedule && isBSchedule) return Compare(a.text, b.text);
        if (isASchedule) return -1;
        if (isBSchedule) return 1;
        
        // 都不在班表中，按名字排序
        return Compare(a.text, b.text);

      })
      ph = phTemp.map(x=>{
        // 找出該藥師的排班
        var sch = scheduledPh.find(s => s.UserId == x.value);
        if (sch != null)
        {
          //的診間
          var room = roomCode.find(c => c.value == sch.RoomCode);
          //x.text+= `(${room?.text ?? "不分診"})`;
           return {...x, text: `${x.text}(${room?.text ?? "不分診"})`};
        }
        return { ...x };
      });

    }else{
      /**藥師下拉選項 */
      ph = await this.scheduleApi.GetPharmarcist(new Date(), sec);  //藥師下拉選單
    }
    ph.push({ text: '無藥師', value: 0 }) // 不管有沒有藥師，都加入吳耀施選項，因為可以委外(=無藥師)ex巡診要委外
    this.pharList = [...ph];

    // 取一些session來的設定，要記得登出後會沒有session， 會 == undefined
    /**session紀錄的藥師Id */
    var phSelected = this.session.getPhar();
    /**session紀錄是否勾寫卡 */
    var defCardWite = this.session.getData('writeCardData') ?? hst001.IsWriteICDefault;
    /**session紀錄是否勾EMR */
    var defUseEmr = this.session.getData('useEmr');
    /**sitSelected 紀錄 clinicsessionsetting 的table id */
    var sitSelected = this.session.getData('SituationId'); //用這個id查table Type == 1 表 useOutVisit ；Type == 2 表 useOutVisitJail
    /**判斷情境的ID是否為本院，不是本院就不能沿用，因為如果沒登出可能記錄到別家的 */
    const existsit = sit.some(item => item.value == sitSelected);
    /**判斷藥師ID是否為本院，不是本院就不能沿用，因為如果沒登出可能記錄到別家的 */
    const existph = ph.some(item => item.value == phSelected);

    // 是否勾選衛星藥局 預設 之前num改bool多做一些防呆
    var defSat = this.session.getData('useSatellite');
    var defuseSatellite;

    if (typeof defSat == 'boolean') {
      defuseSatellite = defSat;
    } else if ((defSat == undefined || defSat == null) && (ph[0].value == 0)) {
      defuseSatellite = true; //登出後，重登會看是否平常使用的有衛星藥局
    } else if (typeof defSat == 'number') {
      defuseSatellite = defSat > 0;
    } else {
      defuseSatellite = false;
    }

    /**從情境的 Addition 中取得 EMRXmlPath */
    var getSessionEmrPath = (sessionId: number): string => {
      if (sessionId <= 0) return '';
      var session = sitlist.find(s => s.Id === sessionId);
      if (!session || !session.Addition) return '';

      // 判斷是否為巡診類型
      if (session.Type !== ClinicSessionTypeEnum.OutVisit &&
          session.Type !== ClinicSessionTypeEnum.OutVisitJail) {
        return '';
      }

      try {
        var addition = JSON.parse(session.Addition);
        return addition.EMRXmlPath || '';
      } catch (e) {
        return '';
      }
    };

    /**畫面預設值:情境 */
    var sitValue = existsit ? sitSelected : sit[0].value;

    // 先判斷選中的情境類型
    var selectedSession = sitlist.find(s => s.Id === sitValue);
    var isOutVisitSession = selectedSession &&
      (selectedSession.Type === ClinicSessionTypeEnum.OutVisit ||
      selectedSession.Type === ClinicSessionTypeEnum.OutVisitJail);

    /**本院所參數是否有EMR路徑 */
    var hasEmrPath = (!hst001.EMRXmlPath || hst001.EMRXmlPath == ' ') ? false : true;

    /**選中的情境是否有EMR路徑 (且必須是巡診類型) */
    var sessionEmrPath = getSessionEmrPath(sitValue);
    var hasSessionEmrPath = sessionEmrPath && sessionEmrPath.trim() !== '';

    /**是否要顯示EMR checkbox */
    var shouldShowEmr = isOutVisitSession
      ? hasSessionEmrPath  // 如果是巡診,只看巡診的 EMR 設定
      : hasEmrPath;        // 如果是一般院內,看參數的 EMR 設定

    /**畫面預設值:EMR勾勾 - 如果任一有設定則預設勾選 */
    var useEmrValue = shouldShowEmr ? (defUseEmr == undefined ? true : defUseEmr) : false;

    /**畫面預設值:衛星勾勾 */
    var useIPValue = defuseSatellite == undefined ? true : defuseSatellite;
    /**畫面預設值:寫卡勾勾 */
    var isWriteCardValue = defCardWite == undefined ? true : defCardWite;
    /**畫面預設值:藥師 */
    var phValue = existph ? phSelected : ph[0].value;

    // === 牙科 巡診感控SOP 勾選 ===
    /** 是否為牙科診所 */
    const isDental = UserCache.getLoginUser().Clinic.Type === ClinicTypeEnum.DentistClinic;
    /** 巡診類型集合 */
    const outVisitTypes = new Set<number>([
      ClinicSessionTypeEnum.OutVisit,
      ClinicSessionTypeEnum.OutVisitJail,
      ClinicSessionTypeEnum.OutVisitMedLackArea,
      ClinicSessionTypeEnum.OutVisitMtn,
    ]);
    /** 判斷指定情境ID是否為巡診情境 */
    const isOutVisitSit = (sitId: number): boolean => {
      if (!sitId || sitId <= 0) return false;
      const s = sitlist.find(x => x.Id === sitId);
      return !!s && outVisitTypes.has(s.Type);
    };
    /** 取得院內預設「偏遠醫療巡診 SOP」設定（僅牙科有意義） */
    let clinicOutVisitSopDefault = 0;
    if (isDental && sitlist.some(x => outVisitTypes.has(x.Type))) {
      try {
        const today = new Date();
        const monthStr = `${today.getFullYear()}/${String(today.getMonth() + 1).padStart(2, '0')}/01`;
        const paramSet = await this.paramSetApi.GetLast(UserCache.getLoginClinicId(), monthStr, 1, '');
        clinicOutVisitSopDefault = paramSet?.InfectionControlRemoteMedical ?? 0;
      } catch (e) {
        console.warn('[巡診感控SOP] 取得 InfectionControlRemoteMedical 預設失敗，使用 0', e);
      }
    }
    /** cookie key 產生器 */
    const sopCookieKey = (sitId: number) => `dental_outvisit_sop_${sitId}`;
    /** 取得指定情境下的 SOP 預設勾選值 */
    const resolveOutVisitSopValue = (sitId: number): boolean => {
      if (!isOutVisitSit(sitId)) return false;
      const c = this.cookieService.getCookie(sopCookieKey(sitId));
      if (c === '1') return true;
      if (c === '0') return false;
      return clinicOutVisitSopDefault === 1;
    };

    /**全部的選項 */
    var formField: FormFieldCollection<{ ph: number, isWriteCard: boolean, useEmr: boolean, useSatIP: boolean, SituationId: number, outVisitSop: boolean }> = {};
    formField.ph = { label: '值班藥師', name: 'ph', value: phValue, data: ph, type: 'dropdown', order: 1 };
    formField.isWriteCard = { label: '寫IC卡', name: 'isWriteCard', value: isWriteCardValue, type: 'check', order: 2 };
    formField.useEmr = { label: '電子病歷', name: 'useEmr', value: useEmrValue, type: 'check', order: 3 };
    formField.useSatIP = { label: '衛星藥局', name: 'useSatIP', value: useIPValue, type: 'check', order: 4 };
    formField.SituationId = {
      label: '情境選擇', name: 'SituationId', value: sitValue, data: sit, type: 'dropdown', order: 5
      , tip: '情境"衛星"為設定值，若要傳送，請勾選上方衛星藥局',
    };
    formField.outVisitSop = {
      label: '巡診感控SOP', name: 'outVisitSop',
      value: resolveOutVisitSopValue(sitValue),
      type: 'check', order: 6,
      hidden: !(isDental && isOutVisitSit(sitValue)),
      tip: '此設定會以情境為單位記憶到本機。',
    };
    // 當情境切換時，動態顯隱「巡診感控SOP」並依 cookie/院內設定刷新預設值
    formField.SituationId.onChange = async (data: any) => {
      const sopField: any = formField.outVisitSop;
      if (!sopField) return;
      const newSitId = data?.SituationId;
      const show = isDental && isOutVisitSit(newSitId);
      sopField.hidden = !show;
      // 重新計算當前情境對應的勾選值（patch 回 form 值）
      data.outVisitSop = show ? resolveOutVisitSopValue(newSitId) : false;
    };

    /**必顯示項目 */
    let baseFields: (keyof typeof formField)[] = ['ph', 'isWriteCard'];
    /**有條件的顯示項目 */
    let conditionalFields: { [K in keyof typeof formField]?: boolean } = {
      useEmr: shouldShowEmr,
      useSatIP: sitlist.some(item => item.SatellitePhamacyIP !== ''),
      SituationId: sitlist.length > 0,
      // 牙科 + 至少有一個巡診情境時，才把欄位納入表單；實際顯隱由 hidden 屬性控制
      outVisitSop: isDental && sitlist.some(x => outVisitTypes.has(x.Type)),
    };

    var finalFormField = this.buildFormField(formField, baseFields, conditionalFields);

    /**最終的顯示框 */
    var formValueDialog = await this.easyForm.show({
      title: '設定',
      msg: '請選擇值班藥師',
      fields: finalFormField,
      hideClose: true,
      beforeSubmit: async (data) => {
        var formValue = data as any;

        // 根據最終選擇的情境, 重新判斷 EMR
        var finalSession = sitlist.find(s => s.Id === formValue.SituationId);
        var isFinalOutVisit = finalSession &&
          (finalSession.Type === ClinicSessionTypeEnum.OutVisit ||
          finalSession.Type === ClinicSessionTypeEnum.OutVisitJail);

        var finalSessionEmrPath = getSessionEmrPath(formValue.SituationId);
        var finalHasSessionEmrPath = finalSessionEmrPath && finalSessionEmrPath.trim() !== '';

        var finalShouldShowEmr = isFinalOutVisit
          ? finalHasSessionEmrPath
          : hasEmrPath;

        if (finalShouldShowEmr && (formValue.useEmr == null || formValue.useEmr == undefined)) {
          formValue.useEmr = true;
        }

        if (!finalShouldShowEmr) {
          formValue.useEmr = false;
        }

        var useOutVisit = false;
        var useOutVisitJail = false;
        var useDentalOutVisit = false;
        var outVisitSessionType: number | null = null;
        var dentalOutVisitMountainIsland = false;
        var hsaip = false;
        var useip = formValue.useSatIP;
        var additionPrintSetting = '';
        var emrXmlPath = '';
        //有情境ID，就能用情境Type欄位確認是哪種巡診
        if (formValue.SituationId > 0) {
          var useSit = sitlist.filter(item => item.Id == formValue.SituationId);
          const selectedSit = useSit.length > 0 ? useSit[0] : null;
          outVisitSessionType = selectedSit?.Type ?? null;
          useOutVisit = (selectedSit != null && selectedSit.Type == ClinicSessionTypeEnum.OutVisit);
          useOutVisitJail = (selectedSit != null && selectedSit.Type == ClinicSessionTypeEnum.OutVisitJail);
          useDentalOutVisit = !!selectedSit && isDental && outVisitTypes.has(Number(selectedSit.Type));
          dentalOutVisitMountainIsland = useDentalOutVisit && selectedSit != null &&
            isDentalMountainIslandArea(selectedSit.DefaultSupArea || '');
          additionPrintSetting = selectedSit ? selectedSit.Addition : '';
          hsaip = (selectedSit != null && selectedSit.SatellitePhamacyIP !== '');
          // 從 Addition 中解析並獨立儲存 EMRXmlPath
          if (additionPrintSetting) {
            try {
              var parsed = JSON.parse(additionPrintSetting);
              emrXmlPath = parsed.EMRXmlPath || '';
            } catch (e) {
              console.error('解析 Addition 失敗:', e);
              emrXmlPath = '';
            }
          }
        }
        //選擇的情境沒有衛星藥局，要先把衛星藥局清掉
        if (useip && !hsaip) {
          useip = false;
        }

        if (useip && formValue.ph > 0) {
          await this.userConfirm.showConfirm(
            {
              title: '設定不一致警告！！！',
              msg: `有開啟衛星藥局，已將值班藥師調整為"無藥師"\n\n若要修改請重新整理瀏覽器確認您的設定`,
              hideNo: true,
              textYes: '確認',
              width: 400
            })
          formValue.ph = 0;
        }

        this.session.setPhar(formValue.ph);
        this.session.setData('writeCardData', formValue.isWriteCard);
        this.session.setData('useEmr', (formValue.useEmr == null || formValue.useEmr == undefined) ? false : formValue.useEmr);
        this.session.setData('useSatellite', (useip == null || useip == undefined) ? false : useip);
        this.session.setData('SituationId', (formValue.SituationId == null || formValue.SituationId == undefined) ? 0 : formValue.SituationId);
        this.session.setData('useOutVisit', useOutVisit);
        this.session.setData('useOutVisitJail', useOutVisitJail);
        this.session.setData('useDentalOutVisit', useDentalOutVisit);
        this.session.setData('outVisitSessionType', outVisitSessionType);
        this.session.setData('dentalOutVisitMountainIsland', dentalOutVisitMountainIsland);
        this.session.setData('additionPrintSetting', (formValue.SituationId == null || formValue.SituationId == undefined) ? '' : additionPrintSetting);

        // 獨立儲存 EMR 路徑
        this.session.setData('emrXmlPath', emrXmlPath);

        this.session.setData('loginSituation', (sitlist as any[]).find(item => item.Id == formValue?.SituationId) ?? null)

        // 牙科 巡診感控SOP：依情境寫入 cookie，並把目前值寫入 session 供病歷端讀取
        if (isDental && isOutVisitSit(formValue.SituationId)) {
          const sopVal: boolean = !!formValue.outVisitSop;
          this.cookieService.setCookie(sopCookieKey(formValue.SituationId), sopVal ? '1' : '0');
          this.session.setData('dentalOutVisitSop', sopVal ? 1 : 0);
        } else {
          this.session.setData('dentalOutVisitSop', null);
        }

        await this.onReloadSelectPhar.emit();
        return true;
      }
    });

    // var useOutVisit = false;
    // var useOutVisitJail = false;
    // var hsaip = false;
    // var useip = formValue.useSatIP;
    // //有情境ID，就能用情境Type欄位確認是哪種巡診
    // if (formValue.SituationId > 0) {
    //   var useSit = sitlist.filter(item => item.Id == formValue.SituationId )
    //   useOutVisit = (useSit.length > 0 && useSit[0].Type == ClinicSessionTypeEnum.OutVisit);
    //   useOutVisitJail = (useSit.length > 0 && useSit[0].Type == ClinicSessionTypeEnum.OutVisitJail);
    //   hsaip = (useSit.length > 0 && useSit[0].SatellitePhamacyIP !== '' );
    // }
    // //選擇的情境沒有衛星藥局，要先把衛星藥局清掉
    // if (useip && !hsaip) {
    //   useip = false;
    // }

    // if (useip && formValue.ph > 0) {
    //   await this.userConfirm.showConfirm(
    //     {
    //       title: '設定不一致警告！！！',
    //       msg: `有開啟衛星藥局，已將值班藥師調整為"無藥師"\n\n若要修改請重新整理瀏覽器確認您的設定`,
    //       hideNo: true,
    //       textYes: '確認',
    //       width: 400
    //     })
    //     formValue.ph = 0;
    // }

    // this.session.setPhar(formValue.ph);
    // this.session.setData('writeCardData', formValue.isWriteCard);
    // this.session.setData('useEmr'      , (formValue.useEmr == null || formValue.useEmr == undefined) ? false : formValue.useEmr);
    // this.session.setData('useSatellite', (useip == null || useip == undefined) ? false : useip);
    // this.session.setData('SituationId', (formValue.SituationId == null || formValue.SituationId == undefined) ? 0 : formValue.SituationId);
    // this.session.setData('useOutVisit', useOutVisit);
    // this.session.setData('useOutVisitJail',useOutVisitJail);
  }

  private buildFormField<T>(
    formField: T,
    baseFields: (keyof T)[],
    conditionalFields: { [K in keyof T]?: boolean }
  ): Partial<T> {
    let ff: Partial<T> = {};

    // 基礎
    baseFields.forEach(field => {
      if (formField[field] != null) {
        ff[field] = formField[field];
      }
    });

    // 條件
    (Object.entries(conditionalFields) as [keyof T, boolean][]).forEach(([field, condition]) => {
      if (condition && formField[field] != null) {
        ff[field] = formField[field];
      }
    });
    return ff;
  }


  public async checkPwdChange() {
    if (this.userData.needChangePwd) {
      var msg = !this.userData.lastChangePasswordTime
                ?'尚未設定密碼，請更新您的密碼。'
                :('因應健保署補助專案之資安規範，至少每三個月需變更一次密碼。\r\n您前一次更新密碼的日期為' + DateHelper.getROCDateStringWithSepetator(this.userData.lastChangePasswordTime,'/') + '。');
      await this.showChangePwd(msg)
    }
    var sys001 = await this.clinicDataService.getParam('SYS101');
    // 警告 雙因子驗證尚未設定
    if(sys001.Enable2FVWarning && this.userData.twoFactorValue== TwoFactorValue.None){
      await this.userConfirm.showAlert('安全性提醒',
        '<span class="controlled-font-size-large">為了保護您的帳號安全，強烈建議您進行<span style="color:red;font-weight:bold">雙重驗證</span>登入設定。</span><br><br>'+
        '設定方式：<br>'+
        '  1️⃣ 點選系統<span style="color:red;">右上角</span>帳號名稱<br>'+
        '  2️⃣ 選擇「<span style="color:red;">安全性設定</span>」<br>'+
        '  3️⃣ 選擇「<span style="color:red;">簡訊</span>」驗證或「<span style="color:red;">電子郵件</span>」驗證擇一<br>'+
          '4️⃣ 輸入手機或信箱後可進行測試再<span style="color:red;">儲存</span><br>'+
        '🚨 手機與信箱之後可以隨時變更',{htmlMsg:true,width:400})
    }
  }

  public async showChangePwd(msg: string = '') {
    var ret = await this.easyForm.show<{ oldPwd: string, newPwd: string, confirmPwd: string }>({
      title: '更改密碼',
      msg: msg,
      tip: '密碼為至少六碼以上，且包含英文與數字。如欲沿用舊密碼請先確認輸入目前密碼。',
      btns: [{
        text: '沿用舊密碼',
        callback: async (data) => {
          if (NullOrEmpty(data?.oldPwd)) {
            this.notify.showError('請先輸入目前密碼');
            return;
          }
          try {
            await this.userApi.changePwd(data.oldPwd, data.oldPwd);
            return { action: 'close', data: null };
          } catch (ex) {
            var errMsg = ex?.message;
            this.notify.showError(NullOrEmpty(errMsg) ? ex : errMsg);
          }
        }
      }],
      beforeSubmit: (async (data) => {
        try {
          await this.userApi.changePwd(data.oldPwd, data.newPwd)
          return true;
        } catch (ex) {
          var msg = ex?.message;
          this.notify.showError(NullOrEmpty(msg) ? ex : msg);
          return false;
        }
      }).bind(this),
      fields: {
        oldPwd: {
          label: '目前密碼',
          name: 'oldPwd',
          type: 'pwd',
          value: '',
          required: true,
          order: 1
        },
        newPwd: {
          label: '新密碼',
          name: 'newPwd',
          type: 'pwd',
          value: '',
          required: true,
          order: 2,
          validator: [Validators.pattern(/^.*(?=.{6,})(?=.*\d)(?=.*[a-zA-Z]).*$/)]
        },
        confirmPwd: {
          label: '確認密碼',
          name: 'confirmPwd',
          type: 'pwd',
          value: '',
          required: true,
          order: 3,
          validator: [(c) => {
            if (!c.value) {
              //只顯示必填
              return null
            }
            var er = Validators.pattern(/^.*(?=.{6,})(?=.*\d)(?=.*[a-zA-Z]).*$/)(c);
            if (er) {
              // 只顯示格式不符
              return er;
            } else {
              var newV = c.parent.get('newPwd');
              if (c.value == newV.value) {
                return null;
              } else {
                return { custom: '與新密碼不一致' }
              }
            }
          }]
        }
      }
    })
  }

  async checkMonthSchedule() {
    var hasMonth = await this.scheduleApi.HasMonthSchedule(new Date());
    // 取得周排班資料
    var weeklyData: Schedule[] = await this.api.get('GetWeekly').toPromise();
    if (hasMonth == false) {
      var msgText = "查無包含今日之後的月排班資料。\n請選擇欲從周排班進行轉換的時間範圍";  // 無月排班但有周排班
      if (weeklyData.length <= 0) {
        msgText = "查無包含今日之後的月排班資料。\n請先建立排班資料";  // 無月排班也無周排班
      }
      var opts = await this.scheduleApi.GetData();
      await this.easyForm.show<{ startDate: Date, endDate: Date }>({
        title: '是否建立月排班',
        msg: msgText,
        fields: {
          startDate: {
            label: '開始日期',
            type: 'date',
            value: new Date(),
            name: 'startDate',
            required: true,
            order: 1,
            validator: [
              ValidationTipComponent.MaxDate(new Date(opts.lastGenMonthDate)),
              ValidationTipComponent.MinDate(new Date())
            ],
          }, endDate: {
            label: '結束日期',
            type: 'date',
            value: new Date(opts.lastGenMonthDate),
            name: 'endDate',
            required: true,
            order: 2,
            validator: [
              ValidationTipComponent.MaxDate(new Date(opts.lastGenMonthDate)),
              ValidationTipComponent.MinDate(new Date())
            ],
          }
        },
        showBtnCancel: true,
        beforeSubmit: async (data) => {
          try {
            await this.scheduleApi.GenMonthFromWeek(data.startDate, data.endDate);
            this.notify.showSuccess('月排班建立完成');
          } catch (ex) {
            this.notify.showError(ex)
          }
          return true;
        }
      })
    }
  }

  vpnState: VPNState = 'Fail';
  pingRs: (boolean) => void;
  pingTimeout = null;
  lastTryDt: Date = null;
  reloadAngle = 0;
  Ping_VPN(): Promise<boolean> {

    if (this.pingTimeout != null) {
      throw '正在等候結果';
    }
    if (this.lastTryDt != null && (new Date().getTime() <= (this.lastTryDt.getTime() + 5000))) {
      throw '操作時間過近';
    }
    this.lastTryDt = new Date();
    var p = new Promise<boolean>((rs, rj) => {
      this.pingRs = rs;
    })
    var ip = 'medvpn.nhi.gov.tw/'
    var img = new Image();
    img.onload = async () => {
      await vpnSuccess();
    };
    img.onerror = async () => {
      await vpnSuccess();
    };

    var st = new Date();
    var vpnSuccess = async () => {
      this.vpnState = 'Ok';
      if (this.pingTimeout != null) {
        clearTimeout(this.pingTimeout);
        this.pingTimeout = null;
      }
      var sec = (new Date().getTime() - st.getTime());
      if (sec > 3000) {
        this.vpnState = 'Slow';
      }
      this.pingRs(true);
    }

    this.pingTimeout = setTimeout(async () => {
      console.log(new Date().toLocaleTimeString(), 'VPN Time Out')
      console.log('Ping_VPN timeout')
      this.vpnState = 'Fail';
      this.pingRs(false);
      var ret = await this.userConfirm.showConfirm(
        {
          title: '警告！！！',
          msg: '無法連線至健保VPN，請重試一次或者檢查您的網路環境。',
          textYes: '重試',
          textNo: '確認'
        })
      this.logger.ClientLog('Info', true, 'VPN測試失敗');
      img.onload = null;
      img.onerror = null;
      img.src = '';
      this.pingTimeout = null;
      if (ret) {
        this.Ping_VPN();
      }
    }, 5000);
    setTimeout(() => {
      img.src = "https://" + ip;
    }, 0);

    return p;
  }

  async updateLabImport() {
    try {
      var lab001Params = await this.clinicDataService.getParam("LAB001");
      if (lab001Params?.EnableLabImport !== true) {
        return;
      }

      var ret = await this.labApi.ImportLab('');
      if (ret.ImportCount) {
        await this.userConfirm.showAlert('匯入結果', `新取得 ${ret.ImportCount} 筆匯入資料。\n更新 ${ret.LabForms.length} 筆檢驗報告。`)
      }
    } catch (e) {
      this.notify.showErrorWithPrefix('檢驗匯入資料取得失敗：', e, false, false);
    }
  }
  async getAnnoucementAlert() {
    await this.announcement.init();
    await this.announcement.alertOnLogin();
  }

  /**
   * 不是總部診所，且沒開啟總部庫存功能，要檢查總部診所是否有開啟總部庫存，有的話要提示。
   * 但不強制，因為有可能各診所是陸續上線庫存系統，等各診所要上線時才開啟。
   */
  async checkHeadquartersStockSystemAsync() {
    try {
      if (this.isStockHeadquarters) {
        return;
      }

      var stk001 = await this.clinicDataService.getParam("STK001");
      var clinicId = UserCache.getLoginClinicId();
      const result = await this.productApi.GetHeadquartersStockParamAsync(clinicId);

      if (stk001.EnableStockSystem == false && result.EnableStockSystem) {
        this.notify.showWarning('總部已經[啟用庫存系統]功能，請確認目前診所是否同步[啟用庫存系統]。', false);
      }
      if (stk001.EnableHeadquarterRx == false && result.EnableHeadquarterRx) {
        this.notify.showWarning('總部已經[啟用總部藥材]功能，請確認目前診所是否同步[啟用總部藥材]。', false);
      }
      if (stk001.EnableRealtimeStock == false && result.EnableRealtimeStock) {
        this.notify.showWarning('總部已經[啟用即時計算庫存]功能，請確認目前診所是否同步[啟用即時計算庫存]。', false);
      }
    } catch (e) {
      console.error('檢查總部庫存設定失敗：', e);
    }
  }


  async checkStockAlert() {
    try {
      const user = UserCache.getLoginUser();
      if (!user.IsSuper && !user.CanLoginPromptInsufficientInventory) {
        return;
      }

      var stk001 = await this.clinicDataService.getParam("STK001");
      if (stk001.EnableStockSystem == false) {
        return;
      }

      const result = await this.productApi.CheckStockAlert();
      if (result && (result.LowStockCount > 0 || result.BatchNearExpiryCount > 0 || result.BatchExpiredCount > 0)) {
        this.onStockAlertDetected.emit(result);
      }
    } catch (e) {
      // 靜默處理錯誤，不阻擋登入流程
      console.error('檢查庫存警示失敗：', e);
    }
  }




  /** 取得藥師下拉選單 */
  getPharyList() {
    return this.pharList;
  }
  private idleTimeMs = 1 * 60 * 1000; // 5 分鐘
  private idleTimer?: ReturnType<typeof setTimeout>;
  private logoutTimer?: ReturnType<typeof setTimeout>;
  public waitTime = '';
  private idleTime = new Date();
  async initIdleMonitor() {
    var p = await this.clinicDataService.getParam('SYS101');
    if(p.IdleLimit>0){
      this.setupListeners();
      this.resetIdleTimer(p.IdleLimit);
      setInterval(()=>
      {
        var sec  = Math.floor((this.idleTime.getTime() - new Date().getTime())/1000);
        var hour = Math.floor(sec/3600)
        sec = Math.floor(sec%3600)
        var min = Math.floor(sec/60)
        sec = Math.floor(sec%60)
        var t = [hour,min,sec].map(x=>x.toString().padStart(2,'0')).join(':')
        if(t!=this.waitTime){
          this.waitTime = `(${t})`;
        }
      },200);
    }

  }

  stopIdleMonitor() {
    this.removeListeners();
    this.clearTimers();
  }

  private setupListeners() {
    [//'mousemove','keydown',
      'input',
      'click', 'touchstart'].forEach(event =>
      document.addEventListener(event, this.activityListener, true)
    );
  }

  private removeListeners() {
    ['mousemove', 'keydown', 'click', 'touchstart'].forEach(event =>
      document.removeEventListener(event, this.activityListener, true)
    );
  }

  private activityListener =  async() => {
    var p = await this.clinicDataService.getParam('SYS101');
    this.resetIdleTimer(p.IdleLimit);
  };
    private resetIdleTimer(idleTime:number) {
    this.clearTimers();
    if(idleTime<=0){
      return;
    }
    this.idleTime =DateHelper.addMinute(new Date(),idleTime);
    this.idleTimer = setTimeout(async () => {
      // 提示使用者
      var count = 10;
      var msg = ()=>`您已閒置 5 分鐘，即將自動登出，是否繼續使用？${count--}`;
      var waiter = await this.userConfirm.showWaiter('閒置過久',msg(),{

      },(ret)=>{
        if(ret){
          waiter.wait = 'done'
          this.resetIdleTimer(idleTime); // 使用者選擇繼續使用
        }else{
          this.logoutUser();
        }
      });
      waiter.disableYes = false;
      this.logoutTimer = setInterval(async () => {
        waiter.msg = msg();
        if(count <0){
          await this.logoutUser();
        }
      }, 1000);
    }, this.idleTimeMs);

  }
  private clearTimers() {
    if (this.idleTimer) clearTimeout(this.idleTimer);
    if (this.logoutTimer) clearTimeout(this.logoutTimer);
  }
  private async logoutUser() {
    await this.auth.logout();
    // 可改成呼叫 AuthService.logout() 或導回登入畫面
  }
  async updateUIColor(){
    var sys102 = await this.clinicDataService.getParam("SYS102");
    var setValueIf = (key,value)=>{
      if(key && value){
        document.documentElement.style.setProperty(key, value);
      }
    }

      // 對照表在 SYS102Params.ts（表單模式「顏色風格套用」的示意圖也用它讀取預設色）
      (Object.keys(SYS102_CSS_VARS) as (keyof SYS102Params)[]).forEach(k => setValueIf(SYS102_CSS_VARS[k], sys102[k]));
      // //-- 未設定
      //主底色
      // setValueIf('--font-color', sys102.FontColor||'#eee');
      // setValueIf('--main-color', sys102.MainColor||'#666');
      // setValueIf('--main-bg',sys102.TabFontColor2||'#555');
      // setValueIf('--vis-btn-bg',sys102.Button0Color||'#222');
      // setValueIf('--vis-btn-font', sys102.Button0FontColor||'#ddd');
      // setValueIf('--vis-btn-bg-hover',sys102.Button0HoverColor||'#666');
      // setValueIf('--vis-btn-font-hover', sys102.Button0HoverFontColor||'#ddd');
      // setValueIf('--vis-grid-header-color',sys102.GridHeaderColor||'#444');
      // setValueIf('--vis-toggle-active',sys102.ToggleColor||'#aaa' );


      // setValueIf('--vis-dialog-bg',sys102.DialogBg||'#888');
      // //門診
      // //主色系 (側邊攔)
      // setValueIf('--vis-hist-main',sys102.HistPanelTitleBg||'black');
      // setValueIf('--vis-hist-main-font',sys102.HistPanelTitleFont||'white');
      // setValueIf('--vis-hist-main-btn',sys102.HistPanelTitleBtn||'#666');
      // //各區標頭
      // setValueIf('--vis-hist-card-title-bg',sys102.HistCardTitle||'#000');
      // setValueIf('--vis-hist-card-title-font',sys102.HistCardTitleFont||'#ddd');
      // setValueIf('--vis-history-bg-color',sys102.HistViewGridBg||'#222');
      // setValueIf('--vis-history-bg-color-odd',sys102.HistViewGridBgOdd||'#555');
      // setValueIf('--vis-history-bg-color-selected',sys102.HistViewGridBgSelected||'#888');

      // //配盤項目游標放上去
      // setValueIf('--vis-hist-pad-hover',sys102.HistPadHover||'#ddd');
      // setValueIf('--vis-hist-pad-font-hover',sys102.HistPadHoverFont||'#444');
      // //門診TextArea focus顏色
      // setValueIf('--vis-hist-input-focus-bg',sys102.HistAreaFocusBg||'#444');
      // setValueIf('--vis-hist-input-focus-font',sys102.HistAreaFocusFont||'#eee');
      // setValueIf('--vis-hist-input-bg',sys102.HistAreaBg||'#111');
      // setValueIf('--vis-hist-input-font',sys102.HistAreaFont||'#eee');

      // //診斷名稱
      // setValueIf('--vis-hist-input-disable-bg',sys102.HistAreaDisableBg||'#000');
      // setValueIf('--vis-hist-input-disable-font',sys102.HistAreaDisableFont||'#888');
      // //醫令區
      // setValueIf('--vis-hist-cell-input-bg',sys102.HistTableCellBg||'#aaa');
      // setValueIf('--vis-hist-cell-input-font',sys102.HistTableCellFont||'#111');
      // setValueIf('--vis-hist-order-row-bg',sys102.HistTableRowBg||'#333');
      // setValueIf('--vis-hist-order-row-bg-even',sys102.HistTableRowFont||'#555');
      // setValueIf('--vis-hist-order-header-bg',sys102.HistTableHeaderBg||'#777');
      // setValueIf('--vis-hist-order-header-font',sys102.HistTableHeaderFont||'#ddd');
      // //輔助盤
      // setValueIf('--vis-hist-helper-bg',sys102.HistHelperBg||'#999');
      // // 完診按鈕

      // setValueIf('--vis-hist-finish-color',sys102.HistFinishBtnBg||'#ffe566');
      // setValueIf('--vis-hist-finish-font-color',sys102.HistFinishBtnFont||'#474647');
      // setValueIf('--vis-hist-finish-hover-color',sys102.HistFinishBtnHoverBg||'#ffffcc');
      // setValueIf('--vis-hist-finish-hover-font-color',sys102.HistFinishBtnHoverFont||'#474647');

      // setValueIf('--vis-toggle-active-font',sys102.ToggleFontColor||'#222' );
      // setValueIf('--font-color-disabled',sys102.FontColorDisabled||'#aaa' );
      // setValueIf('--vis-card-bg',sys102.cardBg||'#111' );
      // //必填input底
      // setValueIf('--vld-required-bg-color',sys102.InputRequired||'#008' );
      /**
  --vis-btn-primary-color: #00425f;
  --vis-btn-primary-font-color: #fff;
  --vis-btn-primary-hover-color:rgba(0, 68, 97, .85);
  --vis-btn-secondary-color: #fe824c;
  --vis-btn-secondary-font-color: #fff;
  --vis-btn-secondary-hover-color:rgba(254, 130, 76, .85);
  --vis-btn-third-color: #66e5e1;
  --vis-btn-third-font-color: #474647;
  --vis-btn-third-hover-color:rgba(102, 229, 225, .85);
       *
       */

  }

  async checkEMRPath(){
    var emrPath = await this.clinicDataService.GetEMRPath();
    // 網路磁碟位置
    if(emrPath){
      // 檢查此路徑是否能通
        try{
          var ret = await this.hcrService.PathCheck(emrPath,1) // 1秒timeout
          if(ret.Successed ==false){
            this.notify.showError('EMR 路徑無法連線: '+emrPath);
          }
        }catch(e){
          this.notify.showError('EMR 路徑無法連線: '+emrPath);
        }
    }
  }
}
